import servicesUtils from "../../../utils/servicesUtils";
const getMatchingPatient = (patient_id: number) => {
  return servicesUtils.getService(`/patients/${patient_id}/match/?threshold=50`);
};

export default getMatchingPatient;
